// Permite seleccionar el día del control diario y navegar entre fechas hasta el día operativo actual.
import React, { useRef, useState } from 'react'
import { Button, IconButton } from '@mui/material'
import { DateObject } from 'react-multi-date-picker'
import { CalendarBlank, CaretDown, CaretLeft, CaretRight } from '@phosphor-icons/react'
import AppDatePicker from '../../components/AppDatePicker'
import dayjs from '../../utils/dayjsConfig'
import { canSelectDailyDate, getDailyDateLabel } from './helpers/singleDayNavigatorHelpers'
import {
  DAILY_NAVIGATOR_CONFIG,
  DAILY_NAVIGATOR_TEXT
} from './constants/singleDayNavigatorConstants'

export default function SingleDayNavigator({ date, today, onChange, disabled }) {
  const calendarRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  if (!date || !today) return null
  const selected = dayjs(date)
  const maximum = dayjs(today)
  const choose = (value) => {
    if (disabled || !canSelectDailyDate(value, maximum)) return
    onChange(value.format(DAILY_NAVIGATOR_CONFIG.DATE_FORMAT))
    calendarRef.current?.closeCalendar()
  }
  return (
    <div className="daily-control-day">
      <IconButton
        size="small"
        aria-label={DAILY_NAVIGATOR_TEXT.PREVIOUS_DAY}
        disabled={disabled}
        onClick={() => choose(selected.subtract(1, 'day'))}
      >
        <CaretLeft size={18} />
      </IconButton>
      <AppDatePicker
        ref={calendarRef}
        containerClassName="daily-control-day-picker"
        value={new DateObject({ date, format: DAILY_NAVIGATOR_CONFIG.DATE_FORMAT })}
        maxDate={new DateObject({ date: today, format: DAILY_NAVIGATOR_CONFIG.DATE_FORMAT })}
        onChange={(value) =>
          choose(value ? dayjs(value.format(DAILY_NAVIGATOR_CONFIG.DATE_FORMAT)) : null)
        }
        format={DAILY_NAVIGATOR_CONFIG.DATE_FORMAT}
        portal
        zIndex={DAILY_NAVIGATOR_CONFIG.CALENDAR_Z_INDEX}
        calendarPosition={DAILY_NAVIGATOR_CONFIG.CALENDAR_POSITION}
        disabled={disabled}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        render={(_, openCalendar) => (
          <Button
            variant="outlined"
            disabled={disabled}
            startIcon={<CalendarBlank size={18} />}
            endIcon={<CaretDown size={15} />}
            aria-label={DAILY_NAVIGATOR_TEXT.SELECT_DAY}
            aria-haspopup="dialog"
            aria-expanded={isOpen}
            onClick={openCalendar}
          >
            <span className="daily-control-day-label">{getDailyDateLabel(date, today)}</span>
          </Button>
        )}
      />
      <IconButton
        size="small"
        aria-label={DAILY_NAVIGATOR_TEXT.NEXT_DAY}
        disabled={disabled || !selected.isBefore(maximum, 'day')}
        onClick={() => choose(selected.add(1, 'day'))}
      >
        <CaretRight size={18} />
      </IconButton>
    </div>
  )
}
